import React from 'react';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { useBreakpoint } from '../../helpers/breakpoint-provider';
import {
  CarouselItem,
  VideoWrapper,
  VideoTitleCountWrapper,
  VideoTitle,
  VideoCount,
  VideoLearnMoreLink,
  CarouselWrapper
} from './styles';

const getCarouselScrollSpeed = () => {
  const { isMobile, isTabletSm, tabletMd, isDesktop } = useBreakpoint();

  if (isMobile || isTabletSm) return 1;
  if (tabletMd) return 2;
  if (isDesktop) return 3;

  return 1;
};

export const VideoCarousel = ({ videos, showMoreLink }) => {
  const { tabletMd, isDesktop } = useBreakpoint();
  const { trackEvent } = useAnalytics();

  const videoCount = videos?.length;

  const itemWidth = 337;
  const carouselHeight = showMoreLink ? 330 : 280;
  const arrowPlacement = {
    left: '-60px',
    right: '-60px',
    top: '110px'
  };

  const carouselItemStyle = {
    margin: '0 10px',
    height: showMoreLink ? '275px' : '245px',
    width: `${itemWidth - 20}px`
  };

  return (
    <CarouselWrapper
      key={new Date()}
      itemWidth={itemWidth}
      height={carouselHeight}
      arrowPlacement={arrowPlacement}
      showArrows={(tabletMd || isDesktop) && videoCount > 2}
      scrollSpeed={getCarouselScrollSpeed()}
    >
      {videos?.map((video, count) => {
        const node = video?.node || video;
        return (
          <CarouselItem key={node.id} style={carouselItemStyle}>
            <VideoWrapper youtubeId={node.youtube_id} />
            <VideoTitleCountWrapper showMoreLink={showMoreLink}>
              <VideoTitle>{node.video_name}</VideoTitle>
              <VideoCount>
                {count + 1}/{videoCount}
              </VideoCount>
            </VideoTitleCountWrapper>
            {showMoreLink && node?.topic?.topic_url && (
              <VideoLearnMoreLink
                to={`/${node?.topic?.topic_url}`}
                onClick={() =>
                  trackEvent('content_engagement_v2', {
                    engagement_type: 'learn_more_link_click',
                    link: node?.topic?.topic_url,
                    data: node
                  })
                }
              >
                Learn more
              </VideoLearnMoreLink>
            )}
          </CarouselItem>
        );
      })}
    </CarouselWrapper>
  );
};

VideoCarousel.defaultProps = {
  showMoreLink: true
};
